import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

import { observer } from "mobx-react-lite";
import { AlertCenterHeader } from "./alert/AlertCenterHeader";
import HeaderAlertIcon from "./UI/HeaderAlertIcon";
import AlertData from "../api/AlertData";
import User from "../api/User";
import ApiData from "../api/ApiData";
import Media from "../api/Media";
import RolesState from "../api/RolesState";
import HeaderNavIcon from "./UI/HeaderNavIcon";
import NotesWidget from "../api/NotesWidget";
import { HeaderReportTemplates } from "./HeaderReportTemplates";
import { HeaderLicenseCalculator } from "./HeaderLicenseCalculator";

const Header = observer(({ visibleHeader, setVisibleHeader }) => {
  const location = useLocation();
  const user = User.user;
  const canViewProfile = Boolean(
    user?.is_superuser || user?.permission?.includes("get_my_profile"),
  );

  const [widthHeader, setWidthHeader] = useState(180);
  const [paddingHeader, setPaddingHeader] = useState("15px 15px 40px 15px");

  const handlerHeaderBar = (collapsed) => {
    if (collapsed) {
      if (!Media.mobile) {
        setWidthHeader(40);
        setPaddingHeader("15px 6px 40px");
      } else {
        setPaddingHeader("15px 10px ");
      }
    } else {
      setWidthHeader(180);
      setPaddingHeader("15px 15px 40px 15px");
    }
  };

  useEffect(() => {
    if (Media.mobile) {
      handlerHeaderBar(true);
    } else {
      handlerHeaderBar(!visibleHeader);
    }
  }, [Media.mobile, visibleHeader]);

  const isMyCompaniesActive = location.pathname === "/my-companies";

  const isCompanyActive =
    location.pathname === "/company" ||
    location.pathname.startsWith("/company/");

  const isPartnersActive =
    location.pathname === "/partners" ||
    location.pathname.startsWith("/partners/");

  const isEmployeesActive =
    location.pathname === "/employees" ||
    location.pathname === `/employees/${ApiData?.employee?.id}`;

  const isReportActive = location.pathname === "/allreport";
  const isAdminActive = location.pathname === "/adminpanel";
  const isProfileActive = location.pathname === "/profile";

  const showNavIcons = Media.mobile || !visibleHeader;

  const visibleBar = () => {
    setVisibleHeader(!visibleHeader);
  };

  const navLinkClass = (active) =>
    active ? "link-header link-header--active" : "link-header";

  return (
    <div
      className={!Media.mobile ? "header" : "header_mobile"}
      style={{ minWidth: widthHeader + "px", padding: paddingHeader }}
    >
      {location.pathname === "/login" ||
      localStorage.getItem("User") === null ||
      location.pathname === "/" ? (
        <>
          {!Media.mobile ? (
            <div className="header__title-logo-container">
              <NavLink to={"/company"}>
                <h1 className="header__title-logo-dmc">DMC</h1>
                <p className="header__title-logo-lk">личный кабинет</p>
              </NavLink>
            </div>
          ) : (
            null
          )}
        </>
      ) : (
        <>
          <nav className="nav-container">
            {!Media.mobile ? (
              <button
                type="button"
                className="media_btn_header_container"
                onClick={visibleBar}
                aria-expanded={visibleHeader}
                aria-label={
                  visibleHeader
                    ? "Свернуть боковую панель"
                    : "Развернуть боковую панель"
                }
                title={
                  visibleHeader
                    ? "Свернуть боковую панель"
                    : "Развернуть боковую панель"
                }
              >
                <svg
                  className={`media_btn_header${visibleHeader ? "" : " media_btn_header--collapsed"}`}
                  viewBox="0 0 24 24"
                  width="12"
                  height="12"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d="M15 18l-6-6 6-6" />
                </svg>
              </button>
            ) : (
              null
            )}

            <div
              className={!Media.mobile ? "header__title-logo-container" : ""}
            >
              {Media.mobile || !visibleHeader ? (
                null
              ) : (
                <NavLink to={"/company"}>
                  <h1 className="header__title-logo-dmc">DMC</h1>
                  <p className="header__title-logo-lk">личный кабинет</p>
                </NavLink>
              )}

              {RolesState.subscription_rights || user?.is_superuser ? (
                <NavLink
                  className={AlertData.cls_visible_alert}
                  to={"/alertcenter"}
                  aria-label="Центр уведомлений"
                  title="Центр уведомлений"
                >
                  <HeaderAlertIcon
                    className="alert_error_counter_header_icon_animation_on"
                  />
                  {!ApiData.observableReportLic ? <AlertCenterHeader /> : null}
                </NavLink>
              ) : (
                null
              )}
            </div>
            <nav className={!Media.mobile ? "nav-menu" : "nav-menu-mobile"}>
              {ApiData.showMyCompaniesNav ? (
                <NavLink
                  onClick={() => ApiData.setParameters("noRight", false)}
                  className={navLinkClass(isMyCompaniesActive)}
                  to={"/my-companies"}
                  aria-label="Мои компании"
                  title="Мои компании"
                >
                  {showNavIcons ? (
                    <HeaderNavIcon
                      name="favorite"
                      active={isMyCompaniesActive}
                    />
                  ) : (
                    <span>Мои компании</span>
                  )}
                </NavLink>
              ) : null}
              {RolesState.companys ? (
                <NavLink
                  onClick={() => ApiData.setParameters("noRight", false)}
                  className={navLinkClass(isCompanyActive)}
                  to={"/company"}
                  aria-label="Компании"
                  title="Компании"
                >
                  {showNavIcons ? (
                    <HeaderNavIcon name="company" active={isCompanyActive} />
                  ) : (
                    <span>Компании</span>
                  )}
                </NavLink>
              ) : (
                null
              )}
              {RolesState.company_partners ? (
                <NavLink
                  onClick={() => ApiData.setParameters("noRight", false)}
                  className={navLinkClass(isPartnersActive)}
                  to={"/partners"}
                  aria-label="Партнёры"
                  title="Партнёры"
                >
                  {showNavIcons ? (
                    <HeaderNavIcon name="partners" active={isPartnersActive} />
                  ) : (
                    <span>Партнёры</span>
                  )}
                </NavLink>
              ) : (
                null
              )}
              {RolesState.emploees ? (
                <NavLink
                  onClick={() => ApiData.setParameters("noRight", false)}
                  className={navLinkClass(isEmployeesActive)}
                  to={"/employees"}
                  aria-label="Сотрудники"
                  title="Сотрудники"
                >
                  {showNavIcons ? (
                    <HeaderNavIcon name="employees" active={isEmployeesActive} />
                  ) : (
                    <span>Сотрудники</span>
                  )}
                </NavLink>
              ) : (
                null
              )}
              {RolesState.all_soft_client || RolesState.subscription_rights ? (
                <NavLink
                  onClick={() => ApiData.setParameters("noRight", false)}
                  className={navLinkClass(isReportActive)}
                  to={"/allreport"}
                  aria-label="Отчёты"
                  title="Отчёты"
                >
                  {showNavIcons ? (
                    <HeaderNavIcon name="report" active={isReportActive} />
                  ) : (
                    <span>Отчёты</span>
                  )}
                </NavLink>
              ) : (
                null
              )}

              {RolesState.admin_panel ? (
                <NavLink
                  onClick={() => ApiData.setParameters("noRight", false)}
                  className={navLinkClass(isAdminActive)}
                  to={"/adminpanel"}
                  aria-label="Админ панель"
                  title="Админ панель"
                >
                  {showNavIcons ? (
                    <HeaderNavIcon name="admin" active={isAdminActive} />
                  ) : (
                    <span>Админ панель</span>
                  )}
                </NavLink>
              ) : (
                null
              )}
            </nav>
          </nav>
          {canViewProfile ? (
            <div className="header-profile-block">
              <HeaderReportTemplates showNavIcons={showNavIcons} />
              <HeaderLicenseCalculator showNavIcons={showNavIcons} />
              {NotesWidget.enabled ? (
                <button
                  type="button"
                  className="header-notes-trigger"
                  onClick={() => NotesWidget.toggleOpen()}
                  aria-pressed={NotesWidget.open}
                  aria-label={
                    NotesWidget.dueReminderCount > 0
                      ? `Мои заметки, напоминаний: ${NotesWidget.dueReminderCount}`
                      : "Мои заметки"
                  }
                  title="Мои заметки"
                >
                  <span className="header-notes-trigger__icon-wrap">
                    {showNavIcons ? (
                      <HeaderNavIcon name="notes" active={NotesWidget.open} />
                    ) : (
                      <span>Мои заметки</span>
                    )}
                    {NotesWidget.dueReminderCount > 0 ? (
                      <span className="header-notes-badge" aria-hidden="true">
                        {NotesWidget.dueReminderCount > 9
                          ? "9+"
                          : NotesWidget.dueReminderCount}
                      </span>
                    ) : null}
                  </span>
                </button>
              ) : null}
              <NavLink
                onClick={() => ApiData.setParameters("noRight", false)}
                className={`lk-nav${isProfileActive ? " lk-nav--active" : ""}`}
                to={"/profile"}
                aria-label="Профиль"
                title="Профиль"
              >
                <HeaderNavIcon name="profile" active={isProfileActive} />
                {!showNavIcons ? (
                  <div className="lk-nav-name">
                    <span>{user?.last_name}</span>
                    <span>{user?.first_name}</span>
                  </div>
                ) : null}
              </NavLink>
            </div>
          ) : (
            null
          )}
        </>
      )}
    </div>
  );
});

export default Header;
